import { AiFillTikTok } from "react-icons/ai";
import {
  FaFacebook,
  FaInstagram,
  FaRegCopyright,
  FaWhatsapp,
  FaYoutube,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { useSettings } from "context/SettingsContext";
import { t } from "context/translations";

const FooterSection = () => {
  const { theme, language } = useSettings();
  const isDark = theme === "dark";
  return (
    <div className={`${isDark ? "bg-[#020618]" : "bg-[#020618]"} pb-[58px]`}>
      <div className="mx-6 pt-3 p-1 md:pt-2 md:mx-10 md:p-4">
        {/* Wrapper → behaves differently on mobile vs md+ */}
        <div className="grid grid-cols-1 gap-x-4 gap-y-2 md:flex md:justify-between md:gap-x-6 md:gap-y-6">
          {/* Column 1 */}
          <div className="text-white flex-1" lang="bn">
            <div className="flex  py-2">
              <Link to="/" className="flex ">
                <p>Super Store</p>
                {/* <img
                  src={logo}
                  alt="Super Store Logo"
                  className="md:h-12 h-8 w-auto"
                /> */}
              </Link>
            </div>
            <p className="md:mb-2 mb-1 md:text-base text-xs">
              {t("shopAddress", language)}
            </p>

            {/* <a
  href="https://www.google.com/maps/search/?api=1&query=Bonolota+Market,+Newmarket,+Dhaka,+New+Market,+Dhaka+1205
"
  target="_blank"
  rel="noopener noreferrer"
  className="inline-block mt-2 text-blue-600 underline hover:text-blue-800"
>
  View on Google Maps
</a> */}

            <p className="md:mb-2 mb-1 md:text-base text-xs text-gray-400 ">
              {t("phoneNumber", language)}
            </p>
            <p className="md:mb-2 mb-1 md:text-base text-xs text-gray-400 ">
              {t("helpline", language)}
            </p>
            {/* <p className="md:mb-2 mb-1 md:text-base text-xs text-black ">ইমেইল: nohababycollection@gmail.com</p> */}
          </div>

          {/* Mobile grid (2 columns), md+ flex children */}
          <div className="grid grid-cols-2 gap-4 md:flex md:flex-1 md:gap-6">
            {/* Column 2 */}
            <div className="text-gray-400 md:py-5 py-2 flex-1">
              {/* <h3
                lang="bn"
                className="mb-3 font-semibold lg:text-xl md:text-lg text-sm"
              >
                আমাদের সম্পর্কে
              </h3> */}
              <div className="md:mb-2 mb-1">
                <Link
                  to="/aboutUs"
                  className="md:text-base text-xs text-gray-400 "
                >
                  {t("aboutUs", language)}
                </Link>
              </div>
              <div className="md:mb-2 mb-1">
                <Link
                  to="/contactUs"
                  className="md:text-base text-xs text-gray-400 "
                >
                  {t("contactUs", language)}
                </Link>
              </div>
              <div className="md:mb-2 mb-1">
                <Link
                  to="/terms&condition"
                  className="md:text-base text-xs text-gray-400 "
                >
                  {t("termsAndCond", language)}
                </Link>
              </div>
              {/* <p className="mb-2 md:text-base text-xs">How to use</p> */}
              {/* <p className="mb-2 md:text-base text-xs text-black ">
                Return Policy
              </p>
              <p className="mb-2 md:text-base text-xs text-black ">
                Refund Policy
              </p>
              <p className="mb-2 md:text-base text-xs text-black ">
                Cancellation Policy
              </p> */}
            </div>

            {/* Column 3 */}
            <div className=" md:py-5 py-2 flex-1">
              <h3
                lang="bn"
                className="text-gray-300  mb-3 font-semibold lg:text-xl md:text-lg text-sm"
              >
                {t("socialMedia", language)}
              </h3>
              <div className=" flex gap-4">
                <FaFacebook className="text-blue-600 text-xl" />
                <AiFillTikTok className="text-gray-400 text-xl" />
                <FaWhatsapp className="text-green-600 text-xl" />
                <FaInstagram className="text-[#fbad50] text-xl" />
                <FaYoutube className="text-red-600 text-xl" />
              </div>
            </div>
          </div>
        </div>
        <div className="flex items-center justify-between gap-2 text-xs text-white border-t border-dashed border-gray-600 pt-2 pb-1">
          <div className="flex items-center gap-1">
            <FaRegCopyright className="text-white" />
            <span>Super Store</span>
          </div>

          <div className="flex items-center gap-1">
            {/* <span>Developed by</span> */}
            <a
              href="https://motionbooster.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary  hover:text-primary/80 transition bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-500 bg-clip-text text-transparent"
            >
              MOTION BOOSTER
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterSection;
